import { useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import BiggoronSword from "../../../core/assets/oot/gshd/biggoron-sword_32x32.png";
import Item from "../../../core/items/Item";
import OotItem, { DbItemProps } from "./OotItem";
import EmptyItem from "./EmptyItem";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";


const id = "Biggoron's Sword";

const BiggoronSwordItem = () => {


    let reduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)

    if (reduce)
        return <EmptyItem />;

    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={"OoT_BiggoronSword"} image={BiggoronSword} title="Biggoron's Sword" isObtained={item?.isObtained}
                updateItem={updateOotItem}
                item={item}
            />
        }
        }
    </OotItem>
}
export default BiggoronSwordItem;


export const SimpleBiggoronSwordItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={BiggoronSword}
        onClick={props.onClick}
        name={id}
    />


}



export const DbBiggoronSwordItem = (props: DbItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultBiggoronSwordItem;

    return <Item
        item={item}
        updateItem={props.update}
        image={BiggoronSword}
        id={id}
        title={id}
        isObtained={item.isObtained}
    />


}

const DefaultBiggoronSwordItem : ItemLightDto = {
    img: BiggoronSword,
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}